import React from "react";
import "./Industry_Standard.css";

const Industry_Standard = () => {
  return (
    <section className="Industry_Standard">
      <div className="Industry_Standard_header">
        <div className="header_div">
          <h5 className="Industry_Standard_title">
            Industry <span>Standard</span>
          </h5>

          <p className="Industry_Standard_subtitle">
            Trusted By Industry. Recognized By The Government.
          </p>
        </div>

        <div className="title_img_div">
          <img
            src="/assets/images/home/Industry_Standard/title-img.png"
            alt="title_img"
            className="title_img"
          />
        </div>
      </div>
      <div className="certificate_div">
        <div className="container">
          <div className="certificate_holder">
            <div className="certificate_img_holder">
              <img
                src="/assets/images/home/Industry_Standard/new2.jpeg"
                alt="certificate"
                className="certificate"
              />
            </div>

            <div className="certificate_img_holder">
              <img
                src="/assets/images/home/Industry_Standard/new3.jpeg"
                alt="certificate"
                className="certificate"
              />
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Industry_Standard;
